import o from "react";
import { Text as l } from "../../../Text/Text.js";
import { cls as c } from "../../../../helpers/cls.js";
const n = _ref => {
  let {
    children: e,
    mode: t = "horizontal"
  } = _ref;
  return e ? o.createElement("div", {
    className: c("olx-ad-card__priceinfo", "olx-ad-card__priceinfo--".concat(t))
  }, t === "vertical" && o.createElement(l.Caption, {
    tag: "p",
    className: "olx-ad-card__priceinfo-text"
  }, e[0]), t === "horizontal" && e.map((a, i) => {
    var r;
    return o.createElement(l.Caption, {
      tag: "p",
      className: "olx-ad-card__priceinfo-text",
      key: (r = a == null ? void 0 : a.toString()) != null ? r : i
    }, a);
  })) : null;
};
export { n as PriceInfo };